import { ExpressiveAnchorButton } from '../../../expressive-button/expressive-anchor-button';
import type { PromoCard } from '../../types';
import { MDSText } from '@midwest/web/base';
import { MDSVStack } from '@midwest/web/stacks';
import styled from 'styled-components';

export const Container = styled(MDSVStack)`
  display: flex;
  width: 100%;
  justify-content: center;

  padding-left: 2.5rem;
  padding-right: 2.5rem;
  padding-top: 2rem;
  padding-bottom: 2rem;
  flex: 1;
  border-radius: 8px;
  margin-top: 1rem;

  background: ${(p) => p.theme.midwestColors.identityBrandPrimaryHeavy};
`;

export const Title = styled(MDSText.BodyHeavyDefault)`
  font-size: 1.125rem;
  line-height: 1.5rem;

  white-space: nowrap;

  color: ${(p) => p.theme.midwestColors.textPrimaryDarkBG};
`;

export const Description = styled(MDSText.BodyRegDefault)`
  width: 100%;

  color: ${(p) => p.theme.midwestColors.textPrimaryDarkBG};

  font-family: 'Basis Grt', sans-serif;
  font-size: 0.95rem;
  font-weight: 400;
  line-height: 145%;

  white-space: normal;
`;

export const CallToAction = styled(ExpressiveAnchorButton).attrs({
  variant: 'darkBg',
  size: 'small',
})`
  display: flex;
  font-family: 'Basis Grt', sans-serif;
  margin-top: 1.5rem;
  max-width: 12.5rem;
`;

type Props = { promoCard: PromoCard };
export const MobileMenuPromoCard = ({ promoCard }: Props) => {
  return (
    <Container>
      <Title>{promoCard.title}</Title>

      <Description>{promoCard.description}</Description>
      <CallToAction href={promoCard.callToActionHref}>
        {promoCard.callToActionText}
      </CallToAction>
    </Container>
  );
};
